import React, {useEffect, useState} from 'react';
import {FloatingBubble, IndexBar, List, SearchBar, Skeleton} from "antd-mobile/2x";
import {
  HTML_TITLE,
  PS_RELOAD_CHANCE_LIST, PS_RELOAD_MERCHANT_LIST,
  URL_MERCHANT_CREATE,
  URL_MERCHANT_DETAIL,
  URL_MERCHANT_LIST,
} from "../../../constant";
import globalStyles from "../../../App.less";
import "./MerchantList.css"
import {Query, Url} from "../../../api/query";
import ChineseHelper from "../../../utils/Pinyin/ChineseHelper";
import {AddOutline} from "antd-mobile-icons";
import {useHistory} from "react-router-dom";
import MyEmpty from "../../MyComponents/MyEmpty/MyEmpty";
import {MerchantTypeText} from "../MerchantForm/MerchantForm";
import {GetQueryString} from "../../../utils/UrlParam";
import {GlobalZoom} from "../../../index";
import PubSub from "pubsub-js";

const MerchantList = (props) => {
  useEffect(() => {
    document.title = HTML_TITLE[URL_MERCHANT_LIST]

    let type = GetQueryString(props.location.search, 'type')
    if (type === null || type === undefined || type === '') {
      type = MerchantTypeText.length
    } else {
      type = Number(type)
    }
    merchantQuerySelf(type)

    const ps_reload_merchant_list = PubSub.subscribe(PS_RELOAD_MERCHANT_LIST, () => {
      merchantQuerySelf(type)
    })
    return () => {
      PubSub.unsubscribe(ps_reload_merchant_list)
    }
  }, [])

  const history = useHistory();

  const [myList, setMyList] = useState([])
  const [myListLoading, setMyListLoading] = useState(false)
  const [myGroups, setMyGroups] = useState([])

  const merchantQuerySelf = (type) => {
    setMyListLoading(true)
    Query(Url.merchantQuery, {type},
      (res) => {
        let list = res.data.list
        for (let i = 0; i < list.length; i++) {
          list[i]["enName"] = ChineseHelper.ConvertPinyin(list[i].name)
          list[i]["enCity"] = ChineseHelper.ConvertPinyin(list[i].city)
        }

        setMyList(list)
        setGroups(list)
        setMyListLoading(false)
      },
      (res) => {
        setMyListLoading(false)
      },
      () => {
        setMyListLoading(false)
      }
    )
  }

  const searchMyList = (value) => {
    const keyword = value.split('').filter((s) => s !== '' && s !== ' ');
    setGroups(myList.filter((item) => {
      let flag = true
      keyword.forEach((k) => {
        if (!item.name.includes(k) && !item.city.includes(k)) {
          flag = false
        }
      })
      return flag
    }))
  }

  const setGroups = (list) => {
    list.sort((o1, o2) => o1.enCity.charCodeAt(0) === o2.enCity.charCodeAt(0)
      ? o1.enName.localeCompare(o2.enName, 'en')
      : o1.enCity.localeCompare(o2.enCity, 'en'))

    let lastInitial = '$'
    let groups = []
    for (let i = 0; i < list.length; i++) {
      const initial = list[i].enCity.charAt(0)
      if (initial !== lastInitial) {
        lastInitial = initial
        groups.push({
          title: initial,
          items: []
        })
      }
      groups[groups.length - 1].items.push(list[i])
    }
    if (groups.length !== 0) {
      groups.push({
        title: '',
        items: []
      })
    }
    setMyGroups(groups)
  }

  const ListDiv = () => {
    let isLoading = false
    isLoading = myListLoading
    return (<div className={globalStyles.body}>
      <div style={{margin: '20px 50px 20px 50px', display: isLoading ? 'block' : 'none'}}>
        <Skeleton.Title animated/>
        <Skeleton.Paragraph lineCount={5} animated/>
      </div>
      <div style={{margin: '80px 50px 20px 50px', display: !isLoading && myGroups.length <= 0 ? 'block' : 'none'}}>
        <MyEmpty/>
      </div>
      <IndexBar style={{display: (isLoading || myGroups.length <= 0) ? 'none' : 'block'}}>
        {myGroups.map(group => {
          const {title, items} = group
          return (
            <IndexBar.Panel index={title} title={title} key={title}>
              <List>
                {
                  items.map(listItem => (
                    <List.Item key={listItem.id}
                               title={<div>{listItem.city} {MerchantTypeText[Number(listItem.type) - 1]}</div>}
                               onClick={() => {
                                 history.push({
                                   pathname: URL_MERCHANT_DETAIL,
                                   state: {merchant: listItem}
                                 })
                               }}>
                      {listItem.name}
                    </List.Item>
                  ))}
              </List>
            </IndexBar.Panel>
          )
        })}
      </IndexBar>
    </div>)
  }

  return (
    <div className={globalStyles.vh_frame}>
      <div className={globalStyles.body}>
        <FloatingBubble
          style={{
            '--initial-position-bottom': '24px',
            '--initial-position-right': '24px',
            '--edge-distance': '24px',
            '--size': '128px',
            '--z-index': '1000',
          }}
          onClick={() => {
            history.push(URL_MERCHANT_CREATE)
          }}
        >
          <div>
            <AddOutline fontSize={60 * GlobalZoom}/>
          </div>
        </FloatingBubble>


        <div className={globalStyles.frame}>
          <div className={globalStyles.top} style={{padding: '20px 24px 0 24px'}}>
            <div style={{margin: '10px 0 30px 0'}}>
              <SearchBar placeholder='查找商户信息（如"北京肯德基"）' showCancelButton
                         onSearch={searchMyList}
                         onClear={() => {
                           setGroups(myList)
                         }}
                         onCancel={() => {
                           setGroups(myList)
                         }}
                         style={{'--height': '80px'}}
              />
            </div>
          </div>
          {ListDiv()}
        </div>
      </div>

    </div>
  );
};


export default MerchantList;